import { ThunkDispatch } from 'redux-thunk'

import { showBankSelectionPopup } from 'features/bankTransfer/duck/actions'
import { BREAK_SIGNAL } from 'features/checkout/duck/operations/postProceed/constants'
import checkoutSelectors from 'features/checkout/duck/selectors'
import { RootState } from 'redux/types'

import {
  BankTransferIdealPostProceedBody,
  BankTransferP24PostProceedBody,
  PrepareBreakSignal,
} from './types'

interface PrepareBankTransferArgs {
  state: RootState
  dispatch: ThunkDispatch<RootState, undefined, any>
}

export function prepareBankTransfer({
  state,
  dispatch,
}: PrepareBankTransferArgs):
  | BankTransferIdealPostProceedBody
  | BankTransferP24PostProceedBody
  | PrepareBreakSignal {
  const isIdealTransfer = checkoutSelectors.getIsIdealBankTransfer(state)
  const isP24Transfer = checkoutSelectors.getIsP24BankTransfer(state)
  const bankID = checkoutSelectors.getSelectedBankId(state)

  if (!bankID) {
    dispatch(showBankSelectionPopup(true))
    return BREAK_SIGNAL
  }

  if (isIdealTransfer) {
    return { issuerID: bankID }
  }
  if (isP24Transfer) {
    return { bankID }
  }

  return BREAK_SIGNAL
}
